import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [sellers, setSellers] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [zonas, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [canal, setCanal] = useState([]);
  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  async function listBureaus() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id});
    if (response.success) setBureaus(response.data);
  }
  async function listCanales() {
    let response = await wsGetAll('sale/canal-incentivo');
    if (response.success) setCanal(response.data);
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
      listZones();
      listBureaus();
      listCanales();
    }
  }, [props.model]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setBureaus([]);
      listBureaus();
    }
  }, [dataChanging.base_zone_id]);


  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/grupo-incentivo-canal'
        dataForce={{
          base_zone_id: dataChanging.base_zone_id,
          base_bureau_id: dataChanging.base_bureau_id,
          state: dataChanging.state,
        }}
      >
        <Autocomplete
          disableClearable
          options={zonas}
          getOptionLabel={(option) => `${option.description}`}
          value={
            zonas.find(
              (item) =>
                String(item.id) === String(dataChanging.base_zone_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Zonas" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange("base_zone_id", item.id);
          }}
          required
        />
        <Autocomplete
          disableClearable
          options={bureaus}
          getOptionLabel={(option) => `${option.description}`}
          value={
            bureaus.find(
              (item) =>
                String(item.id) === String(dataChanging.base_bureau_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Mesas" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange("base_bureau_id", item.id);
          }}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Canal</InputLabel>
          <Select
            required
            value={dataChanging.base_canal_id || ''}
            inputProps={{
              name: 'base_canal_id',
              onChange: (e) => handleChange('base_canal_id', e.target.value),
            }}
          >
            {canal.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Incentivo vendedor"
          fullWidth
          type="number"
          name="incentivo_vendedor"
          margin="normal"
          defaultValue={dataChanging.incentivo_vendedor || ''}
          // onChange={(e) => handleChange('incentivo_vendedor', e.target.value)}
        />
        <TextField
          label="Incentivo supervisor"
          fullWidth
          type="number"
          name="incentivo_supervisor"
          margin="normal"
          defaultValue={dataChanging.incentivo_supervisor || ''}
          // onChange={(e) => handleChange('incentivo_supervisor', e.target.value)}
        />
      </Modal>
    </>
  );
}
